// import store from '@/store'
// import { switchTimeFormat } from '../libs/utils'

// 处理男女性别
export function getSexText(val) {
  if (!val) return ''
  if (val.toString() === '1') return '男'
  if (val.toString() === '2') return '女'
  return '未知'
}
// 处理检查状态
export function scanningStatus (val) {
  if (val === '' || val === null || val === undefined) return ''
  if (val.toString() === '0') return '待接单'
  if (val.toString() === '10') return '等待叫号'
  if (val.toString() === '20') return '已完成'
  if (val.toString() === '5') return '待定'
  if (val.toString() === '8') return '预约完成'
  if (val.toString() === '30') return '退款申请中'
  if (val.toString() === '40') return '已退款'
  if (val.toString() === '-1') return '已过期'
  if (val.toString() === '-10') return '爽约'
  if (val.toString() === '70') return '叫号'
  if (val.toString() === '50') return '已扫描'
  if (val.toString() === '60') return '扫描中'
  if (val.toString() === '-20') return '已取消'
}
// 处理报告状态
export function reportStatus (val) {
  if (val === '' || val === null || val === undefined) return ''
  if (val.toString() === '0') return '默认'
  if (val.toString() === '1') return '待编写'
  if (val.toString() === '10') return '编写中'
  if (val.toString() === '20') return '待审核'
  if (val.toString() === '30') return '审核中'
  if (val.toString() === '100') return '已完成'
  if (val.toString() === '-99') return '已取消'
}
// 处理报告类型
export function reportType (val) {
  if (!val) return ''
  if (val.toString() === '1') return '常规报告'
  if (val.toString() === '5') return 'AI算法'
  // if (val.toString() === '5') return '手工'
  if (val.toString() === '10') return '自动'
  if (val.toString() === '15') return '半自动'
}
// 处理运算中报告状态
export function preProcessingStatus (val) {
  if (val === null) return ''
  if (val.toString() === '0') return '默认'
  if (val.toString() === '5') return '待运算'
  if (val.toString() === '10') return '运算中'
  if (val.toString() === '20') return '运算成功'
  if (val.toString() === '30') return '运算失败'
}
// 后处理
export function getProcessType (num) {
  if (num === null) return ''
  if (num === 1) return '基础序列'
  if (num === 5) return '机器内'
  if (num === 10) return '机器外'
}

// 年龄单位
export function getAgeUnit (num) {
  if (!num) return ''
  if (num === 1) return '小时'
  if (num === 20) return '周'
  if (num === 10) return '天'
  if (num === 30) return '个月'
  if (num === 40) return '季'
  if (num === 50) return '岁'
  return '未知'
}
// 支付状态
export function getPayStatusData (val) {
  if (val === '' || val === null || val === undefined) return ''
  if (val.toString() === '10') return '待支付'
  if (val.toString() === '15') return '支付处理中'
  if (val.toString() === '20') return '支付成功'
  if (val.toString() === '22') return '支付失败'
  if (val.toString() === '25') return '退款申请(全额)'
  if (val.toString() === '30') return '退款审核通过(全额)'
  if (val.toString() === '35') return '退款审核否决(全额)'
  if (val.toString() === '27') return '退款申请(部分)'
  if (val.toString() === '32') return '退款审核通过(部分)'
  if (val.toString() === '37') return '退款审核否决(部分)'
  if (val.toString() === '40') return '已发货'
  if (val.toString() === '45') return '确认收货'
  if (val.toString() === '-29') return '已退款(全额)'
  if (val.toString() === '-32') return '已退款(部分)'
  if (val.toString() === '-99') return '已取消'
  if (val.toString() === '-1') return '已过期'
}

export function changeDoctorName (val) {
  return val
  // const modules = store._modules.root.state
  // const { currentCenterId } = modules.app
  // if (![63, 64].includes(currentCenterId)) {
  //   return val
  // }
  // if (!val) return val
  // const keyNames = {
  //   '63': {
  //     'write': '刘启南',
  //     'check': '程小奇'
  //   },
  //   '64': {
  //     'write': '张雪梅',
  //     'check': '赵荣'
  //   }
  // }
  // const currentDate = switchTimeFormat(new Date(), 1)
  // if (currentCenterId === 64 && currentDate === '2025-03-20') {
  //   return keyNames[currentCenterId.toString()][type]
  // } else if (currentCenterId === 63 && currentDate === '2025-03-21') {
  //   return keyNames[currentCenterId.toString()][type]
  // } else {
  //   return val
  // }
}
